import type { MarkNotificationAsDelivered200SourceSourceUser } from './markNotificationAsDelivered200SourceSourceUser';

export type MarkNotificationAsDelivered200Source = {
  sourceUser?: MarkNotificationAsDelivered200SourceSourceUser;
  /** @nullable */
  sourceUserId?: number | null;
};
